<template>
  <div>
    <v-card class="mt-4 mb-6 pt-1 flicker-card">
      <v-row>
        <v-col>
          <flicker-percentage-card-info :test="test" />
        </v-col>
        <v-col class="mr-4">
          <flicker-index-card-info :test="test" />
        </v-col>
      </v-row>
    </v-card>
    <h4>{{ $t("room.illumination.flicker.percentage") }}</h4>
    <niko-slider
      :min="-1"
      :max="100"
      suffix="%"
      step="1"
      :value="measuredFlickerPercentage"
      placeholder="-"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'measured_flicker_percentage',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
          debouncedSetMeasuredFlickerPercentage(value);
        }
      "
    />
    <h4>{{ $t("room.illumination.flicker.index") }}</h4>
    <niko-slider
      :min="-0.01"
      :max="1"
      step="0.01"
      :value="measuredFlickerIndex"
      placeholder="-"
      textFieldType="text"
      @onChange="
        (value) => {
          const options = {
            index,
            attribute: 'measured_flicker_index',
            newValue: value,
          };
          changeIlluminationTestAttribute(options);
          debouncedSetMeasuredFlickerIndex(value);
        }
      "
    />
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import NikoSlider from "../../UI/NikoSlider";
import FlickerPercentageCardInfo from "./FlickerPercentageCardInfo.vue";
import FlickerIndexCardInfo from "./FlickerIndexCardInfo.vue";

export default {
  name: "tester-flicker",
  components: { NikoSlider, FlickerPercentageCardInfo, FlickerIndexCardInfo },
  props: ["test", "index"],
  computed: {
    ...mapState("roomStore", ["room_id"]),
    measuredFlickerPercentage() {
      return this.test.measured_flicker_percentage ?? null;
    },
    measuredFlickerIndex() {
      return this.test.measured_flicker_index ?? null;
    },
  },
  methods: {
    ...mapMutations("roomStore", ["changeIlluminationTestAttribute"]),
    ...mapActions("projectStore", [
      "setMeasuredFlickerPercentage",
      "setMeasuredFlickerIndex",
    ]),
    debouncedSetMeasuredFlickerPercentage: debounce(function (value) {
      this.setMeasuredFlickerPercentage({
        illumination_test_id: this.test.illumination_test_id,
        measured_flicker_percentage: value,
      });
    }, 500),
    debouncedSetMeasuredFlickerIndex: debounce(function (value) {
      this.setMeasuredFlickerIndex({
        illumination_test_id: this.test.illumination_test_id,
        measured_flicker_index: value,
      });
    }, 500),
  },
};
</script>

<style lang="scss">
.flicker-card {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 4px;
  padding: 8px 22px;
}
</style>
